// Composables/providers/registry.ts
// Provider registry — maps NUXT_PUBLIC_AUTOCOMPLETE_PROVIDER to adapter via lazy import
import { GeocodingProviderEnum } from '~/enums'
import { selectProvider } from './selectProvider'
import type { AutocompleteProvider } from './interfaces'

const registry: Record<GeocodingProviderEnum, () => Promise<AutocompleteProvider>> = {
  [GeocodingProviderEnum.MAPBOX]: () => import('./mapbox').then((module) => module.mapboxAdapter),
  [GeocodingProviderEnum.GOOGLE]: () => import('./google').then((module) => module.googleAdapter)
}

export async function resolveProvider(): Promise<AutocompleteProvider> {
  return registry[selectProvider(useRuntimeConfig().public)]()
}
